import pick from 'lodash/pick';

import type { EventDefinition } from '../../types';

export const compete_answer_comparison_action: EventDefinition = {
  getData: (action, eventData = {}) => ({
    type: action,
    ...pick(eventData, [
      'dataset_id',
      'question_id',
      'question_index',
      'total_questions',
      'answer_a_version',
      'answer_b_version',
      'selected_option',
      'selected_version',
      'completed_questions',
    ]),
  }),
};
